(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

  var tagElements;
  var elementLimit = 0;

  var loadProductRecommendationsIntoSection = function() {
      
      var productRecommendationsSection = document.querySelector(".product-recommendations");
      if (productRecommendationsSection === null) { return; }
      var productId = productRecommendationsSection.dataset.productId;
      var limit = elementLimit;
      var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
  
      request.onload = function() {
  
          if (request.status >= 200 && request.status < 300) { 
              var container=document.createElement("div");
              container.innerHTML += request.response;
              productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
          } 
      }; 
          
      request.send(); 
  };
  
  function hideExcess(){

    var items = document.querySelectorAll('.recommendation-item-outer');

    items.forEach((item)=>{
      item.style.display = 'none';
    });

    for(let i=0;i<4;i++){
      items[i].style.display = 'block';
    }
  }                                                         
  
  document.addEventListener('DOMContentLoaded', (event) => {
	
	setTimeout(function(){

        tagElements = document.getElementsByClassName('recommendation-item-outer');
        if(tagElements.length > 0){
          elementLimit = 4 - tagElements.length;

        } else {
          elementLimit = 4;

        }
        loadProductRecommendationsIntoSection();



      setTimeout(function(){
		//hideExcess();
      }, 500)

    }, 1500)

  })
 
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendationsNew"]) return;
  try {
    

var loadProductRecommendationsIntoSection = function() {
    
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) { return; }
    var productId = productRecommendationsSection.dataset.productId;
    var limit = 3;
    var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);

    request.onload = function() {

        if (request.status >= 200 && request.status < 300) { 
            var container=document.createElement("div");
            container.innerHTML=request.response;
            productRecommendationsSection.parentElement.innerHTML=container.querySelector(".product-recommendations").innerHTML;
        } 
    }; 
        
    request.send(); 
};

document.addEventListener("shopify:section:load", function(event) { 
    if(event.detail.sectionId==="product-recommendations" ) { 
        loadProductRecommendationsIntoSection(); 
    } 
});

loadProductRecommendationsIntoSection(); 


  } catch(e) { console.error(e); }
})();
})();
